// src/pages/Unauthorized.tsx
import {Link, useLocation, useNavigate} from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserType } from '../api/ApiTypes';
import {useEffect} from "react";

export const Unauthorized = () => {
    const { me } = useAuth();
    const location = useLocation();
    const navigate = useNavigate()
    const attemptedUrl = location.state?.attemptedUrl || 'unknown page';


    useEffect(() => {
        //dumb race condition crap when switching users
        if (attemptedUrl.includes("backdoor")) {
            navigate("/dashboard");
        }
    }, [attemptedUrl]);

    // Get readable role name
    const getUserRole = (userType: UserType | undefined) => {
        if (userType === undefined) return 'Unknown';

        switch (userType) {
            case UserType.APPRAISER_ADMIN:
                return 'Appraiser Admin';
            case UserType.CLIENT:
                return 'Client';

            case UserType.APPRAISER:
                return 'Appraiser';
            case UserType.STAFF:
                return 'Staff';
            case UserType.SYSTEM:
                return 'System';
            case UserType.REGISTERED:
                return 'Registered User';
            case UserType.SECRET:
                return 'Secret';
            default:
                return 'Unknown';
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>

                <div className="mb-6 text-gray-700">
                    <p className="mb-2">
                        You don't have permission to access:
                    </p>
                    <p className="font-mono bg-gray-100 p-2 rounded mb-4 break-all">
                        {attemptedUrl}
                    </p>
                    {me && (
                        <p>
                            Your current role: <span className="font-semibold">{getUserRole(me.userType)}</span>
                        </p>
                    )}
                </div>

                <div className="flex flex-col space-y-2">
                    <Link
                        to="/dashboard"
                        className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                    >
                        Go to Dashboard
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="bg-gray-200 text-gray-800 py-2 px-4 rounded hover:bg-gray-300 transition duration-200"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};